/**
 * FooterMain component.
 * @module components/Footer/FooterMain
 */

import React from 'react';
import { Container, Row, Col } from 'design-react-kit/dist/design-react-kit';

import { UniversalLink } from '@plone/volto/components';
import {
  FooterNavigation,
  FooterInfos,
  LogoFooter,
  BrandTextFooter,
} from 'design-comuni-plone-theme/components/ItaliaTheme/';
import logo from '@package/components/layout/images/logo-regione-emilia-romagna.png';

/**
 * FooterMain component class.
 * @class FooterMain
 * @extends Component
 */
const FooterMain = () => {
  return (
    <div className="it-footer-main">
      <Container tag="div">
        <section>
          <Row className="clearfix" tag="div">
            <Col sm={12} tag="div" widths={['xs', 'sm', 'md', 'lg', 'xl']}>
              <div className="it-brand-wrapper">
                <UniversalLink href="/">
                  <LogoFooter />
                  <BrandTextFooter />
                </UniversalLink>
                <UniversalLink
                  href="https://www.regione.emilia-romagna.it/"
                  target="_blank"
                >
                  <img
                    className="logo-er-footer"
                    src={logo}
                    width="276"
                    height="55"
                    alt="Accedi al sito della Emilia Romagna"
                  />
                </UniversalLink>
              </div>
            </Col>
          </Row>
        </section>
        <section>
          <FooterNavigation />
        </section>
        <section className="py-4">
          <FooterInfos />
        </section>
      </Container>
    </div>
  );
};

export default FooterMain;
